import PropTypes from 'prop-types';
import { useState } from 'react';
import masterServicesStrings from 'modules/masterServices/strings';

import DropdownMenu from 'modules/common/components/DropdownMenu/DropdownMenu';
import { statusList } from 'modules/common/enums';
import {
  Wrapper,
  SearchBarWrapper,
  SearchBar,
  SearchBarIcon,
  DropdonwWrapper,
} from './MasterServicesFilter.style';

const MasterServicesFilter = ({
  handleSearchBarInputChange,
  handleDropdownInputChange,
  masterServicesListApiCallBody,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const tempStatusList = [{ value: 'all', name: 'All Statuses' }, ...statusList];
  return (
    <Wrapper>
      <DropdonwWrapper>
        <DropdownMenu
          dropdownMenuItemsList={tempStatusList}
          dropdownMenuSelectedObj={tempStatusList.find(type => type.value === selectedStatus?.key)}
          handleDropdownMenuChange={obj => {
            setSelectedStatus(obj);
            handleDropdownInputChange(obj.key);
          }}
          placeholder={masterServicesStrings.masterServicesFilter.statusDropdownPlaceholder}
          objectMapper={{ key: 'value', name: 'name' }}
        />
      </DropdonwWrapper>
      <SearchBarWrapper>
        <SearchBarIcon />
        <SearchBar
          id="search-bar-input"
          placeholder={masterServicesStrings.masterServicesFilter.searchBarPlaceholder}
          onChange={handleSearchBarInputChange}
          value={masterServicesListApiCallBody.searchterm}
        />
      </SearchBarWrapper>
    </Wrapper>
  );
};
MasterServicesFilter.propTypes = {
  handleSearchBarInputChange: PropTypes.func.isRequired,
  handleDropdownInputChange: PropTypes.func.isRequired,
  masterServicesListApiCallBody: PropTypes.shape({
    searchterm: PropTypes.string,
  }).isRequired,
};

export default MasterServicesFilter;
